import React from 'react';
import { OutOfMvpPage } from '../../components/other-pages.jsx';

export function NotFoundPage({ onGoDashboard, onGoBack }) {
  return (
    <div className="content" style={{ maxWidth: 480, padding: 40 }}>
      <div style={{ background: 'var(--bg-elevated)', border: '1px solid var(--border)', borderRadius: 12, padding: 28, boxShadow: 'var(--shadow-sm)' }}>
        <h1 style={{ margin: '0 0 8px', fontSize: 20, fontWeight: 700 }}>Página não encontrada</h1>
        <p style={{ margin: '0 0 20px', fontSize: 14, color: 'var(--text-secondary)', lineHeight: 1.5 }}>
          A URL acessada não corresponde a nenhuma rota do Super Admin.
        </p>
        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
          <button type="button" className="btn primary" onClick={onGoDashboard}>Ir para o Dashboard</button>
          {typeof onGoBack === 'function' && (
            <button type="button" className="btn ghost" onClick={onGoBack}>Voltar</button>
          )}
        </div>
      </div>
    </div>
  );
}

export function RouteUnavailablePage({ title = 'Módulo fora do MVP' }) {
  return <OutOfMvpPage title={title} />;
}
